import * as Bowser from 'bowser';
import { Component, OnInit } from '@angular/core';
import { licenseKey } from '../devextreme-license';
import config from 'devextreme/core/config';
import { iBisAuthService } from '@dohu/ibis-auth';
import { Router } from '@angular/router';
import { iBisUIService } from '@dohu/ibis-common';
import { ProxyService } from './service/proxy.service';
import { locale, loadMessages } from 'devextreme/localization';
import * as devExtremeMessages from '../assets/devExtreme.json';
import * as labelNames from '../assets/label.json';

config({ licenseKey });
declare var require: any
@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})


export class AppComponent implements OnInit {
  title = 'dohu-pingsm-web';
  version: { lastCommitNumber: number; branch: string; shortSHA: string };

  constructor(private auth: iBisAuthService, public proxy: ProxyService, private router: Router, private ui: iBisUIService) {
    this.auth.onAuthFinished.subscribe(_ => {
      console.log(this.auth.isAuth)

    });
  }

  ngOnInit(): void {
    this.version = require('../git-version.json');
    locale('ro');
    loadMessages(<any>labelNames);
    loadMessages(<any>devExtremeMessages);
    const ui = this.proxy.iui.config.ui;
    if (ui.useNativ !== null && ui.useNativ !== undefined) {
      ui.isWindows = !ui.useNativ;
    } else {
      if (window.navigator.userAgent && Bowser) {
        const bowser = Bowser.getParser(window.navigator.userAgent);
        const os = Bowser ? bowser.getOS() || {} : {};
        if (os && os.name) {
          ui.isWindows = os.name === 'Windows';
        } else {
          ui.isWindows = false;
        }
      } else {
        ui.isWindows = false;
      }
    }
  }
}
